import { Typography } from "@mui/material";

export const LineBreak = () => {
    return (
        <Typography>
            &nbsp;
        </Typography>
    );
};